import {createSelector} from 'reselect';
import isCAAS from '../utils/isCAAS';
import {getSiteId} from './selectors';

export default createSelector(
  [getSiteId],
  siteId => isCAAS(siteId),
);
